/* ==============================================================
   Clearance Guys — homepage + chrome behaviour
   --------------------------------------------------------------
   Deliberately small. Dawn already owns the drawer, the disclosure
   menus, predictive search and the announcement rotation; this file
   only adds the two things it has no equivalent for.
   ============================================================== */
(function () {
  'use strict';

  /* ------------------------------------------------------------
     1. Nav drawer close button (M2)

     The design puts an × inside the 310px panel. Dawn's MenuDrawer
     blanket-binds every <button> in the drawer to onCloseButtonClick,
     which closes a *submenu* — it would leave the drawer open, the
     body scroll-locked and the header stuck in .menu-open.

     Listening in the capture phase on the drawer lets us stop the
     event before it reaches Dawn's target-phase handler, then run
     Dawn's real close path by clicking the summary. No fork of
     global.js, no duplicated state handling.
     ------------------------------------------------------------ */
  function wireDrawerClose(drawer) {
    if (!drawer || drawer.dataset.cgCloseWired === 'true') return;
    drawer.dataset.cgCloseWired = 'true';

    drawer.addEventListener(
      'click',
      function (event) {
        var trigger = event.target.closest('.cg-drawer__close');
        if (!trigger || !drawer.contains(trigger)) return;

        event.preventDefault();
        event.stopPropagation();

        var summary = drawer.querySelector('summary.header__icon--menu');
        if (summary) summary.click();
      },
      true
    );
  }

  /* ------------------------------------------------------------
     2. Brand ticker — pause on touch

     Hover and keyboard focus are handled in CSS; touch devices have
     neither, so a press pauses and a release resumes.
     ------------------------------------------------------------ */
  function wireTicker(ticker) {
    if (!ticker || ticker.dataset.cgTickerWired === 'true') return;
    ticker.dataset.cgTickerWired = 'true';

    var pause = function () {
      ticker.setAttribute('data-paused', 'true');
    };
    var resume = function () {
      ticker.setAttribute('data-paused', 'false');
    };

    ticker.addEventListener('touchstart', pause, { passive: true });
    ticker.addEventListener('touchend', resume, { passive: true });
    ticker.addEventListener('touchcancel', resume, { passive: true });
  }

  function init(root) {
    var scope = root || document;
    scope.querySelectorAll('header-drawer').forEach(wireDrawerClose);
    scope.querySelectorAll('[data-cg-ticker]').forEach(wireTicker);
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', function () {
      init(document);
    });
  } else {
    init(document);
  }

  // Theme editor re-renders sections in place.
  document.addEventListener('shopify:section:load', function (event) {
    init(event.target);
  });
})();
